import { createStore } from 'vuex'

export default createStore({
  state: {
    isLogin: false,
    email: ''
  },
  getters: {
  },
  mutations: {
    auth(state, user){
      state.isLogin = true;
      state.email = user;
    }
  },
  actions: {
    fetch(context, user){
      context.commit('auth', user);
    }
  },
  modules: {
  }
})
